<template lang="pug">
  .asset-management-action-buttons(v-if="item")
    .button-group.small
      swap-asset(:item="item", @processSwap="processSwap")
      move-asset(:item="item", @assetMoved="assetMoved")
      router-link.button.button-small.warning(:to="{name:'operations', params:{id:item.id}}") Drain
      .button.alert.small.alert-text(@click="dismiss") Dismiss

</template>

<script>
  import KeplerBackofficeSdk from "../../../../lib/kepler/backoffice";
  import ModalReveal from "../../foundation/ModalReveal";
  import VehicleSlotList from "../../../../pages/backoffice/VehicleList";
  import DismissAsset from "./asset-management/DismissAsset";
  import SwapAsset from "./asset-management/SwapAsset";
  import MaggieHelper from "../../../../maggieHelper";
  import MoveAsset from "./asset-management/MoveAsset";
  import VehicleSlotButtons from "./VehicleSlotButtons";

  export default {
    name: "AssetManagementActionButtons",
    components: {VehicleSlotButtons, MoveAsset, SwapAsset, DismissAsset, VehicleSlotList, ModalReveal},
    props: ['item'],
    created() {


    },
    methods: {
      dismiss() {
        this.$confirm("Are you sure?", `Do you really want to dismiss the vehicle slot<br>${this.item.name} (VS-${this.item.id})?`, () => {
          KeplerBackofficeSdk.vehicleSlots.select(this.item).dismiss((data) => {
            this.$emit('vehicleSlotDismissed', this.item)
            MaggieHelper.notification('dismiss-esit', 'Vehicle slot dismissed')
          })
        })
      },
      assetMoved(item) {
        this.$emit('assetMoved', item)
      },
      processSwap(id) {
        this.$confirm("Are you sure?", `Do you really want to swap VS-${this.item.id} with VS-${id}?`, () => {

          KeplerBackofficeSdk.vehicleSlots.swap({
            first_vehicle_slot_id: this.item.id,
            second_vehicle_slot_id: id
          }, (data) => {
            MaggieHelper.notification('swap-esit', data.result)
          })
        })
      }
    },

  }
</script>

<style lang="sass">
  .asset-management-action-buttons
    .button-group
      justify-content: center

</style>



// WEBPACK FOOTER //
// AssetManagementActionButtons.vue?138d02f2